import { AppConfig } from '@/config/app';
import { useEffect, useRef } from 'react';

/**
 * A custom hook to dynamically update the document's title.
 * @param title The title to set for the document.
 * @param prevailOnUnmount If true, the title will not be reset on component unmount.
 */
export const useDocumentTitle = (title: string, prevailOnUnmount = false) => {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    document.title = `${title} | ${AppConfig.name}`;
  }, [title]);

  useEffect(() => () => {
    if (!prevailOnUnmount) {
      document.title = defaultTitle.current;
    }
  }, [prevailOnUnmount]);
};